import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetWhatsNewQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetWhatsNewQuery = { __typename?: 'Query', whatsNew: { __typename?: 'WhatsNew', releases: Array<{ __typename?: 'WhatsNewRelease', label: string, effectiveOn: string, releaseNotesUrl?: string | null, features: Array<{ __typename?: 'WhatsNewFeature', id: string, key: string, releaseLabel?: string | null, effectiveOn?: string | null, tenantIds: Array<string>, module: Types.WhatsNewModule, featureFlag?: Types.FeatureFlagName | null, tryEarly: boolean, comingSoon: boolean, docsUrl?: string | null, demoUrl?: string | null, tourId?: string | null, imageUrl?: string | null, requestedByMe: boolean, title: { __typename?: 'WhatsNewText', en: string, es?: string | null }, summary: { __typename?: 'WhatsNewText', en: string, es?: string | null }, details: Array<{ __typename?: 'WhatsNewText', en: string, es?: string | null }>, askedBy: Array<{ __typename?: 'WhatsNewAsker', tenantId: string, name: string, askedOn?: string | null }>, status?: { __typename?: 'WhatsNewText', en: string, es?: string | null } | null }> }>, comingSoon: Array<{ __typename?: 'WhatsNewFeature', id: string, key: string, releaseLabel?: string | null, effectiveOn?: string | null, tenantIds: Array<string>, module: Types.WhatsNewModule, featureFlag?: Types.FeatureFlagName | null, tryEarly: boolean, comingSoon: boolean, docsUrl?: string | null, demoUrl?: string | null, tourId?: string | null, imageUrl?: string | null, requestedByMe: boolean, title: { __typename?: 'WhatsNewText', en: string, es?: string | null }, summary: { __typename?: 'WhatsNewText', en: string, es?: string | null }, details: Array<{ __typename?: 'WhatsNewText', en: string, es?: string | null }>, askedBy: Array<{ __typename?: 'WhatsNewAsker', tenantId: string, name: string, askedOn?: string | null }>, status?: { __typename?: 'WhatsNewText', en: string, es?: string | null } | null }> } };

export type WhatsNewFeatureFragment = { __typename?: 'WhatsNewFeature', id: string, key: string, releaseLabel?: string | null, effectiveOn?: string | null, tenantIds: Array<string>, module: Types.WhatsNewModule, featureFlag?: Types.FeatureFlagName | null, tryEarly: boolean, comingSoon: boolean, docsUrl?: string | null, demoUrl?: string | null, tourId?: string | null, imageUrl?: string | null, requestedByMe: boolean, title: { __typename?: 'WhatsNewText', en: string, es?: string | null }, summary: { __typename?: 'WhatsNewText', en: string, es?: string | null }, details: Array<{ __typename?: 'WhatsNewText', en: string, es?: string | null }>, askedBy: Array<{ __typename?: 'WhatsNewAsker', tenantId: string, name: string, askedOn?: string | null }>, status?: { __typename?: 'WhatsNewText', en: string, es?: string | null } | null };

export const WhatsNewFeatureFragmentDoc = new TypedDocumentString(`
    fragment WhatsNewFeature on WhatsNewFeature {
  id
  key
  releaseLabel
  effectiveOn
  tenantIds
  module
  featureFlag
  tryEarly
  comingSoon
  title {
    en
    es
  }
  summary {
    en
    es
  }
  details {
    en
    es
  }
  askedBy {
    tenantId
    name
    askedOn
  }
  status {
    en
    es
  }
  docsUrl
  demoUrl
  tourId
  imageUrl
  requestedByMe
}
    `, {"fragmentName":"WhatsNewFeature"});
export const GetWhatsNewDocument = new TypedDocumentString(`
    query GetWhatsNew {
  whatsNew {
    releases {
      label
      effectiveOn
      releaseNotesUrl
      features {
        ...WhatsNewFeature
      }
    }
    comingSoon {
      ...WhatsNewFeature
    }
  }
}
    fragment WhatsNewFeature on WhatsNewFeature {
  id
  key
  releaseLabel
  effectiveOn
  tenantIds
  module
  featureFlag
  tryEarly
  comingSoon
  title {
    en
    es
  }
  summary {
    en
    es
  }
  details {
    en
    es
  }
  askedBy {
    tenantId
    name
    askedOn
  }
  status {
    en
    es
  }
  docsUrl
  demoUrl
  tourId
  imageUrl
  requestedByMe
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetWhatsNew: build.query<GetWhatsNewQuery, GetWhatsNewQueryVariables | void>({
      query: (variables) => ({ document: GetWhatsNewDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetWhatsNewQuery, useLazyGetWhatsNewQuery } = injectedRtkApi;
